export default __webpack_public_path__ + "static/home-banner-top-47162aa1b99a7b6ada41488136b5469a.png";